module.exports = __webpack_public_path__ + "img/icon-lightbulb-light-blue.a48f96bb.svg";